import { Text as ChakraText, TextProps as ChakraTextProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { getFontFromVariant } from '../../_helpers';
import { InferPropTypes } from '../../types';

const propTypes = {
  children: PropTypes.node.isRequired,
  fontWeight: PropTypes.oneOf(['medium', 'semibold']),
  variant: PropTypes.oneOf(['base', 'code'])
};

const defaultProps = {
  fontWeight: 'medium',
  variant: 'code'
};

export type LabelProps = ChakraTextProps & InferPropTypes<typeof propTypes, typeof defaultProps>;

export default function Label(props: LabelProps): React.ReactElement {
  const { variant, fontWeight, ...rest } = props;

  const fontFamily = getFontFromVariant(variant, fontWeight);

  return (
    <ChakraText
      casing="uppercase"
      fontFamily={fontFamily}
      fontSize="xs"
      fontWeight={fontWeight}
      letterSpacing="0.8px"
      {...rest}
    />
  );
}

Label.propTypes = propTypes;

Label.defaultProps = defaultProps;
